<template>
    <div>
        <div id="header">
<!--            <router-link to="/" custom v-slot="{ navigate }">-->
<!--              <span @click="navigate"  role="link" style="color:blue;"></span>-->
<!--            </router-link>-->
            <i class="el-icon-back" @click="goBack"></i>
            <div id="tit-div">手机登录</div>
            <div id="kong-div"> </div>
        </div>
        <div id="content">
            <div class="cont">
<!--                <div class="cont-d">手机号码</div>:-->
              <div class="cont-d">+86</div>
              <input type="text" v-model="phoneNum" class="phoneNum" placeholder="请输入手机号"oninput="value=value.replace(/[^\d.]/g,'')" />
            </div>
            <div class="cont-p">
<!--                <div class="cont-d">验证码</div>:-->
                <input type="text" v-model="phoneCode" class="phoneCode" placeholder="验证码" oninput="value=value.replace(/[^\d.]/g,'')" style="margin-left: 0.6rem; width: 30%;"/>
                <span class="send-input" v-if="isShow" @click="sendCode" style="font-size: .14rem;margin-top: auto;">获取验证码</span>
                <div v-if="!isShow"><span>{{count}}</span> 秒</div>
            </div>
            <div class="confirm-info" style="display: flex; justify-content:space-between;margin-top:.3rem;width: 100%;font-size: .15rem;">
              <el-checkbox v-model="checkConfirm" label=""></el-checkbox>
              <span class="confirm-info-before-text" style="margin-left: .05rem;">登录即同意</span>
              <router-link to="/userAgree" custom v-slot="{ navigate }">
                <span @click="navigate"  role="link" style="color:blue;">《用户协议》</span>
              </router-link>
              <span class="confirm-info-connect-text">和</span>
              <router-link to="/privacy" custom v-slot="{ navigate }">
                <span @click="navigate"  role="link" style="color:blue;">《隐私协议》</span>
              </router-link>
            </div>
            <div :style="checkConfirm?'background-color:#f04141':''" id="login" @click="login" style="width: 100%">
                登录
            </div>

        </div>

        <div id="nav" style="margin-top:.1rem;margin-bottom:.1rem;overflow: hidden;">
          <div>
            <!-- <img src="../../static/img/247.png" style="width:100%;height:100%;" alt=""> -->
          </div>
        </div>
    </div>
</template>
<script>
import Cookies from 'js-cookie';
import Global from '../utils/book_global'
// import {sendCode} from "../api/h5Request";

export default {
    name:'Login',
    data(){
        return {
          count:0,
          isShow:true,
          checkConfirm:false,
          phoneNum:'',
          phoneCode:'',
          uuid:Global.State.uuid,
          src:'',
          src_id:'',
          fromPath:'',
          userId:'',
          fromWeather:false,
        }
    },
    beforeRouteLeave(to,from,next){

      if(to.name !== 'userAgreement' && to.name !== 'privacy'){
        this.phoneCode = '';
        this.phoneNum = '';
      }
      next()
    },
    methods: {
        login : function() {

            if(!this.phoneNum || this.phoneNum === ''){
              this.$toast.center('手机号码不能为空');
              return;
            }
            if(!this.phoneCode || this.phoneCode === '' || this.phoneCode.length !== 4){
              this.$toast.center('请填写正确四位验证码！');
              return;
            }
            if(!this.checkConfirm){
              this.$toast.center('请查看并同意相关协议后登录');
              return;
            }
            let key = 'Girliaefpqp!$TUJi^#@888';
            let t = new Date().getTime();
            let jiami = '';
            function encryptByDESModeEBC(message,key){
              var keyHex = CryptoJS.enc.Utf8.parse(key);
              var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
              });
              return encrypted.ciphertext.toString();
            }
            var source = JSON.stringify({"phoneNum":this.phoneNum,"code":this.phoneCode,"uuid":this.uuid})
            var cc = encryptByDESModeEBC(CryptoJS.enc.Utf8.parse(source),key+"_"+t);
            jiami = cc;
            let apiUrl = process.env.APP_API_URL;

            this.$http.post(apiUrl+"/user/login",{data: jiami,t: t}
            ).then((response) => {
              // console.log(response);
              if(response.body.status === 1){
                let that = this
                that.$toast.center('登录成功！');
                this.phoneNum = '';
                this.phoneCode = '';
                this.userTool.saveUser(response.body.data);
                setTimeout(function(){
                  that.goBack();
                },2000)
              }else if(response.body.status === -1){
                this.$toast.center('信息异常！');
              }else if(response.body.status === -2){
                this.$toast.center('验证码错误！');
              }else if(response.body.status === -3){
                this.$toast.center('服务器忙，请稍候再试！');
              }
            }).catch((e) => {

            })
        },
        sendCode: function(){
          if(this.phoneNum === ''){
            this.$toast.center('手机号码不能为空');
          }else if(this.phoneNum.length !== 11){
            this.$toast.center('手机号码长度不正确');
          }else{
            this.isShow = false;//倒计时
            this.count = 30; //赋值3秒
            var times = setInterval(() => {
              this.count--; //递减
              if (this.count <= 0) {
                // <=0 变成获取按钮
                this.isShow = true;
                clearInterval(times);
              }
            }, 1000); //1000毫秒后执行

            let key = Global.State.api_key;
            let t = new Date().getTime();
            let jiami = '';
            function encryptByDESModeEBC(message,key){
              var keyHex = CryptoJS.enc.Utf8.parse(key);
              var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
              });
              return encrypted.ciphertext.toString();
            }

            var source = JSON.stringify({"phoneNum":this.phoneNum,"uuid":this.uuid,})
            var cc = encryptByDESModeEBC(CryptoJS.enc.Utf8.parse(source),key+"_"+t);
            jiami = cc;
            let apiUrl = process.env.APP_API_URL;

            this.$http.post(apiUrl+"/sms/send",{data: jiami,t: t}
            ).then((response) => {
              // console.log(response);
              let time = new Date().getTime();
              Cookies.set("book_send_time",time,1);
              if(response.body.status === 1){
                let that = this
                that.$toast.center('发送成功！');
                // setTimeout(function(){
                //   that.$router.push({name:'BeautyList',query:{is_log:1}});
                // },2000)
              }
              if(response.body.status === -1){
                this.$toast.center('发送失败！');
              }
            }).catch((e) => {
              this.$toast.center('发送失败！');
            })
          }
        },
        initSendTime:function(){
          let sendTime = Cookies.get("book_send_time");
          let time = new Date().getTime();
          let sendInterTime = Math.round((time - sendTime)/1000);
          if(sendInterTime < 30){
            this.isShow = false;
            this.count = 30 - sendInterTime;
            var times = setInterval(() => {
              this.count--; //递减
              if (this.count <= 0) {
                // <=0 变成获取按钮
                this.isShow = true;
                clearInterval(times);
              }
            }, 1000); //1000毫秒后执行
          }
        },
        initSrc:function(){
          if(this.$route.query.id){
            this.src_id =  this.$route.query.id;
          }
          if(this.$route.query.src){
            this.src = this.common.decodePath(this.$route.query.src)
          }
          if(this.$route.query.p){
            this.fromPath = this.common.decodePath(this.$route.query.p)
          }
        },
        goBack:function(){
          this.userId = this.userTool.getUserId();
          if(this.src === 'vip' && (!this.userId || this.userId === '') ){
             let lastRouter = this.userTool.getUserLastRouter();
             if(lastRouter && lastRouter.length > 0){
               this.$router.replace({name:lastRouter});
             }else{
               this.$router.replace({path:'/'});
             }
          }else{
            if(this.fromPath && this.fromPath.length > 0 && this.src_id){
              this.$router.replace({path:this.fromPath,query:{id:this.src_id}});
            }else if(this.fromPath){
              this.$router.replace({path:this.fromPath});
            }else if(this.src && this.src_id){
              this.$router.replace({name:this.src,query:{id:this.src_id}});
            }else if(this.src){
              this.$router.replace({name:this.src});
            }else{
              this.$router.replace({path:'/'});
            }
          }
        }
    },
    created:function(){

    },
    mounted:function(){
      this.initSendTime();
      this.initSrc();

      if(this.common.srcFromWeather()){
        this.fromWeather = true;
      }else{
        this.fromWeather = false;
      }
      var _hmt = _hmt || [];
      var hm = document.createElement("script");
      if(this.fromWeather){
        hm.src = "https://hm.baidu.com/hm.js?da9815d6b4a5d97e58c2156c9b3060cf";
      }else{
        hm.src = "https://hm.baidu.com/hm.js?3e969611694dba0a7e1be8513c061efb";
      }
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);

      let that = this;

      setTimeout(function () {
        that.common.loadAd(402,"nav");
      }, 600)

    },
    activated:function (){
      this.initSrc();
      this.phoneCode = '';
      let that = this;
      setTimeout(function () {
        that.common.loadAd(402,"nav");
      }, 600)
    },
    deactivated:function (){
      // console.log("list:deactivated");
    }

}
</script>
<style scoped>
#header{
    padding: 0 .16rem;
    height: .52rem;
    background: #f5f5f5;
    display: flex;
	justify-content: space-between;
	align-items: center;
    color: #ba1515;
    border-bottom: 1px solid #ba1515;
}
#back-div{
    width: .3rem;
}
#back-div img{
    transform: rotate(180deg);
    width: .18rem;
}
#tit-div{
    color: #ba1515;
}
#kong-div{
    height: .3rem;
    width: .3rem;
}
#content{
    padding: .3rem;
}
.cont{
    width: 100%;
    height: .42rem;
    line-height: .42rem;
    display: flex;
    justify-content: flex-start;
    border-bottom: 1px solid #e0e0e0;
    color: #ba1515;
}

.cont-p{
  width: 100%;
  height: .42rem;
  line-height: .42rem;
  display: flex;
  justify-content: flex-end;
  border-bottom: 1px solid #e0e0e0;
  color: #ba1515;
  text-align: center;
  display: -webkit-flex;
  -webkit-justify-content: space-between;
}
.cont-d {
    width: .6rem;
    text-align:justify;
    text-justify:distribute-all-lines;/*ie6-8*/
    text-align-last:justify;/* ie9*/
    -moz-text-align-last:justify;/*ff*/
    -webkit-text-align-last:justify;/*chrome 20+*/
    font-size: .15rem;
}
@media screen and (-webkit-min-device-pixel-ratio:0){/* chrome*/
    .cont-d:after{
        content:".";
        display: inline-block;
        width:100%;
        overflow:hidden;
        height:0;
    }
}
#login{
    width: 1.6rem;
    height: .32rem;
    text-align: center;
    margin: .4rem auto;
    line-height: .32rem;
    color: #fff;
    background: #ee7979;
    border-radius:.04rem;
    font-size: .13rem
}
input::-webkit-input-placeholder,textarea::-webkit-input-placeholder{
  color:#666;
  font-size:.14rem;
}

input:-moz-placeholder,textarea:-moz-placeholder{
  color:#666;
  font-size:.14rem;
}

input::-moz-placeholder,textarea::-moz-placeholder{
  color:#666;
  font-size:.14rem;
}
input:-ms-input-placeholder,textarea:-ms-input-placeholder{
  color:#666;
  font-size:.14rem;
}
</style>



// WEBPACK FOOTER //
// src/view/Login.vue